import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function MenuDetails({ children }) {
  useInjectSaga({ key: 'menuDetails', saga });
  useInjectReducer({ key: 'menuDetails', reducer });

  return React.Children.only(children);
}

MenuDetails.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withMenuDetails } from './withMenuDetails';
export default compose(withConnect, memo)(MenuDetails);
